export const environment = {
  env: 'ppd',
  production: true,
  apiUrl: '/api',
  loginUrl: '/login/keycloak',
  loginUrlSilent: '/login/keycloak?silent',
  logoutUrl: '/logout',
  bypassOAuth: false,
  sentryDSN: 'https://a243e8d163c92d620e912b48ed979ef2@o4509037256900608.ingest.de.sentry.io/4509326259781712',
  sentryTracingOrigins: [window.location.origin],
  sentryTracesSampleRate: 0.0,
  notificationsUrl: '/api/birdz-messenger/notifications',
  notificationsCookiesDomain: 'ppd.apps.birdz.com',
};
